export const BRIA_USER_ASSETS = "bria-user-assets";
export const BRIA_QUALCOMM_SERVER_HOST = "http://localhost:8000";
export const MICROSOFT_PROVIDER_ID = "microsoft.com";
export const GOOGLE_PROVIDER_ID = "google.com";
export const GITHUB_PROVIDER_ID = "github.com";

export enum LeadSourceEnum {
	GOOGLE_SEARCH = "google_search",
	SOCIAL_MEDIA = "social_media",
	HUGGING_FACE = "hugging_face",
	GITHUB = "github",
	EVENT_CONFERENCE = "event_conference",
	OTHER = "other",
}

export const FIBO_LAUNCH_DATE = new Date("2025-10-20");
